import './Composer.css';

const Composer = ({ draft, onDraftChange, onSend, isGenerating, canRevert, onRevert }) => (
    <div className="ai_chat_panel_footer">
        <div className="ai_chat_panel_composer">
            <textarea
                className="ai_chat_panel_input"
                rows={2}
                value={draft}
                onChange={(e) => onDraftChange(e.target.value)}
                onKeyDown={(e) => {
                    // Enter sends, Shift+Enter inserts a new line
                    if (e.key === 'Enter' && !e.shiftKey && !e.nativeEvent.isComposing) {
                        e.preventDefault();
                        onSend();
                    }
                }}
                placeholder="Describe the bot to create…"
                disabled={isGenerating}
            />
            <div className="ai_chat_panel_composer_actions">
                <span className="ai_chat_panel_hint">Enter to send · Shift+Enter for a new line</span>
                {canRevert &&
                    <button className="ai_chat_panel_revert" onClick={onRevert} disabled={isGenerating} title="Undo the last generation">Revert</button>
                }
                <button className="ai_chat_panel_send" onClick={onSend} disabled={isGenerating}>Send</button>
            </div>
        </div>
    </div>
);

export default Composer;
